// extracted by css-extract-rspack-plugin
export default {"trigger":"HeaderAppearanceSettings-module__trigger__hUheK"};